import { memo } from 'react';

import { AssetModalHeaderSeparator } from '~/components/AssetModalV2/Header/components/AssetModalHeaderSeparator';
import { AssetModalVersionsButton } from '~/components/AssetModalV2/Header/components/AssetModalVersionsButton';
import { CloseButton } from '~/components/AssetModalV2/Header/components/CloseButton';
import { Header } from '~/components/AssetModalV2/Header/components/Header';
import { PublicBoardAssetBreadcrumbs } from '~/components/AssetModalV2/Header/components/PublicBoardAssetBreadcrumbs';
import { PublicAssetNavigationArrows } from '~/components/AssetModalV2/Header/PublicAssetComponents/PublicAssetNavigationArrows';
import { PublicOptionsMenu } from '~/components/AssetModalV2/Header/PublicAssetComponents/PublicOptionsMenu';
import { PublicBoardAssetShareButton } from '~/components/AssetModalV2/Header/PublicBoardAssetComponents/PublicBoardAssetShareButton';
import {
  type UseClosePublicAssetModalProps,
  useClosePublicAssetModal,
} from '~/components/AssetModalV2/hooks/useClosePublicAssetModal';
import { usePublicPermissions } from '~/components/PublicPermissionsProvider';
import { canSeeAssetVersions } from '~/utils/permissions/assetPermissions';

export type PublicBoardAssetHeaderProps = Pick<UseClosePublicAssetModalProps, 'onCloseAssetModal'>;

export const PublicBoardAssetHeader = memo(({ onCloseAssetModal }: PublicBoardAssetHeaderProps) => {
  const { closeAssetModal } = useClosePublicAssetModal({ onCloseAssetModal, trackLocation: 'close-button' });
  const { permissions } = usePublicPermissions();
  const canViewAssetVersions = canSeeAssetVersions(permissions);

  return (
    <Header
      headerLeft={
        <div className="flex items-center gap-2">
          {canViewAssetVersions && (
            <>
              <AssetModalVersionsButton />
              <AssetModalHeaderSeparator />
            </>
          )}
          <PublicBoardAssetBreadcrumbs />
        </div>
      }
      headerRight={
        <div className="flex items-center gap-4">
          <PublicOptionsMenu />
          <PublicBoardAssetShareButton />
          <PublicAssetNavigationArrows />
          <AssetModalHeaderSeparator />
          <CloseButton onClose={closeAssetModal} />
        </div>
      }
    />
  );
});

PublicBoardAssetHeader.displayName = 'PublicBoardAssetHeader';
